export const gaCategory = {
    TRAINING_WIZARD : "Training Wizard",
    TRAININGS : "Trainings",
    GOAL_SETTING : "Goal Setting",
    COURSES : "Courses",
    BROWNBAG : "Brownbag",
    EMPLOYEES : "Skill Management",
    CERTIFICATIONS : "Certifications",
    REPORTS: "Reports",
}